import EtablissementAccordCollectif from '@/generated/controls/etablissement/EtablissementAccordCollectif.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: EtablissementAccordCollectif
})
